import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";

// === Load your Stripe publishable key ===
// (Recommended: move this to ENV in production)
const stripePromise = loadStripe(
  "pk_test_51SgtvBFw5aFY6i2fJqtIMbdCHhXno9qgeNsCdc4Xv7q1GFcQLnex738THdoCTQr9jehCbHW3F4tzBOhuoKddIsBq00DJwsaCkG"
);

const StripeFormBase = ({ history }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);
    setMessage("");

    try {
      // Create PaymentIntent on backend
      const { data } = await axios.post("/create-payment-intent", {
        amount: 10000, // 100 THB = 10000 satang
        currency: "thb",
      });

      const card = elements.getElement(CardElement);
      if (!card) {
        setMessage("Card element not found.");
        setLoading(false);
        return;
      }

      const result = await stripe.confirmCardPayment(data.clientSecret, {
        payment_method: {
          card,
          billing_details: {
            name: `${firstName} ${lastName}`.trim(),
          },
        },
      });

      if (result.error) {
        setMessage(result.error.message || "Payment failed.");
      } else if (result.paymentIntent?.status === "succeeded") {
        setMessage("✅ Payment successful!");
        setTimeout(() => history.push("/logincredits100"), 1500);
      } else {
        setMessage(
          `Payment status: ${result.paymentIntent?.status || "unknown"}`
        );
      }
    } catch (err) {
      console.error(err);
      setMessage("Error creating payment.");
    }

    setLoading(false);
  };

  return (
    <div style={{ textAlign: "center", marginTop: 80 }}>
      <h2 style={{ marginBottom: 12 }}>Stripe Payment (THB)</h2>

      <form
        onSubmit={handleSubmit}
        style={{
          maxWidth: 420,
          margin: "0 auto",
          padding: 16,
          borderRadius: 12,
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
        }}
      >
        {/* First / Last Name */}
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          <input
            type="text"
            placeholder="First name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
            style={{
              flex: 1,
              padding: "10px 12px",
              borderRadius: 8,
              border: "1px solid #e6e6e6",
              fontSize: 14,
            }}
          />
          <input
            type="text"
            placeholder="Last name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
            style={{
              flex: 1,
              padding: "10px 12px",
              borderRadius: 8,
              border: "1px solid #e6e6e6",
              fontSize: 14,
            }}
          />
        </div>

        {/* Card info */}
        <div
          style={{
            padding: 12,
            border: "1px solid #e6e6e6",
            borderRadius: 8,
          }}
        >
          <CardElement
            options={{
              hidePostalCode: true,
              style: {
                base: {
                  fontSize: "16px",
                  color: "#32325d",
                  "::placeholder": { color: "#aab7c4" },
                },
                invalid: { color: "#fa755a" },
              },
            }}
          />
        </div>

        {/* Submit */}
        <button
          type="submit"
          disabled={!stripe || loading}
          style={{
            width: "100%",
            marginTop: 16,
            backgroundColor: "#0a74da",
            color: "white",
            padding: "12px 16px",
            border: "none",
            borderRadius: 8,
            cursor: !stripe || loading ? "not-allowed" : "pointer",
            fontWeight: 600,
          }}
        >
          {loading ? "กำลังดำเนินการ..." : "ชำระเงิน 100 บาท"}
        </button>

        {message && <p style={{ marginTop: 12 }}>{message}</p>}
      </form>
    </div>
  );
};

// withRouter for React Router v5
const StripeForm = withRouter(StripeFormBase);

const StripePage100 = () => (
  <Elements stripe={stripePromise}>
    <StripeForm />
  </Elements>
);

export default StripePage100;
